import { Odds } from '@frontend/sports/odds/feature';
import { PlacementErrorType } from '@frontend/sports/types/betslip';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { UserError } from './user-error';

export class UnderMinimumOddsLimit extends UserError {
    constructor(
        public currentOdds: Odds,
        public oddsFormat: OddsDisplayFormat,
        oddsLimit: number | undefined,
    ) {
        super();
        this.oddsLimit = oddsLimit == null ? null : oddsLimit;
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.UnderMinimumOdds;
    }

    oddsLimit: number | null;
}
